// File: client/src/routes/AppRoutes.jsx

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../protected/protected-route';
// Commodity
import Login from '../modules/auth/login';
import Register from '../modules/auth/register';
import Dashboard from '../modules/layout/Dashboard';
import CmsWarehouseForm from '../modules/masters/cma/cma-form';
import CmaAddWarehousesForm from '../modules/masters/cma/cma-add-warehouses-form';
import Profile from '../components/profile/profile';
import CmaList from '../modules/masters/cma/cma-list';

import CommodityForm from '../modules/masters/commodity/commodity-form';
import CommodityList from '../modules/masters/commodity/commodity-list';
import SaleBrokerList from '../modules/masters/broker/sale-broker/sale-broker-list';
import SaleBrokerForm from '../modules/masters/broker/sale-broker/sale-broker-form';
import PurchaseBrokerForm from '../modules/masters/broker/purchase-broker/purchase-broker-form';
import PurchaseBrokerList from '../modules/masters/broker/purchase-broker/purchase-broker-list';
import SupplierList from '../modules/masters/supplier/supplier-list';
import SupplierForm from '../modules/masters/supplier/supplier-form';
import SupplierEditForm from '../modules/masters/supplier/supplier-edit-form';
import CompanyList from '../modules/masters/company/company-list';
import CompanyForm from '../modules/masters/company/company-form';
import CompanyAddGstForm from '../modules/masters/company/company-add-gst-form';
// Purchase Contract
import PurchaseContractList from '../modules/contracts/purchase-contract/purchase-contract-list';
import PurchaseContract from '../modules/contracts/purchase-contract/purchase-contract';
import WarehouseEntryList from '../modules/warehouse/warehouse-entry/warehouse-entry-list';
import WarehouseEntryForm from '../modules/warehouse/warehouse-entry/warehouse-entry-form';
import CostBreakupList from '../modules/cost/cost-breakup-list';
import CostBreakupForm from '../modules/cost/cost-breakup-form';
import MastersOverview from '../modules/masters/MastersOverview';
import DocumentUploadForm from '../components/doc/document-upload-form';
import DocumentList from '../components/doc/document-list';
import SalesOrderFrom from '../modules/sales/sales-order/sales-form';
import SalesOrderList from '../modules/sales/sales-order/sales-list';
import Roadmap from '../modules/layout/Roadmap';
import DeliveryOrderList from '../modules/sales/delivery-order/delivery-list';
import DeliveryOrderForm from '../modules/sales/delivery-order/delivery-form';
import DispatchEntryForm from '../modules/sales/dispatch-order/dispatch-form';
import DispatchList from '../modules/sales/dispatch-order/dispatch-list';
import PaymentList from '../modules/payments/payment/payment-list';
import PaymentForm from '../modules/payments/payment/payment-form';
import BuyerList from '../modules/masters/buyer/buyer-list';
import BuyerForm from '../modules/masters/buyer/buyer-form';
import IssuingAuthoritiesList from '../modules/masters/issuing-authorities/issuing-authorities-list';
import IssuingAuthoritiesForm from '../modules/masters/issuing-authorities/issuing-authorities-form';
import ReceivedPaymentList from '../modules/masters/received-payment/received-payment-list';
import ReceivedPaymentForm from '../modules/masters/received-payment/received-payment-form';
import DeliveryOrderView from '../modules/sales/delivery-order/delivery-view';
import WarehouseTransferForm from '../modules/warehouse/warehouse-transfer/warehouse-transfer-form';
import WarehouseTransferList from '../modules/warehouse/warehouse-transfer/warehouse-transfer-list';
import SalesReport from '../modules/reports/sales-report/sales-report';
import BackupManagement from '../modules/backup-management/backup';
import PurchaseSummaryReport from '../modules/reports/purchase-summary-report/purchase-summary-report';
import MasterReport from '../modules/reports/master-report/MasterReport';

import UserList from '../modules/auth/users-list/user-list';
// Placeholder components for each module (replace with real ones as needed)

const CostComponent = () => <h2>Cost Component</h2>;
const DocumentType = () => <h2>Document Type</h2>;
const FXRate = () => <h2>FX Rate</h2>;
const OrderStatus = () => <h2>Order Status</h2>;
const SaleBroker = () => <h2>Sale Broker</h2>;
const SalesChannel = () => <h2>Sales Channel</h2>;
const Warehouse = () => <h2>Warehouse</h2>;
const AppRoutes = () => {
  return (
    <Routes>
      {/* Project Selection Route */}
      <Route path="/" element={<Login />} />
      
      {/* Auth Routes */}
      <Route path="/login" element={<Login />} />


      {/* Protected Routes */}
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/register" element={<ProtectedRoute><Register /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/broker" element={<ProtectedRoute><SaleBrokerList /></ProtectedRoute>} />
      <Route path="/broker/new" element={<ProtectedRoute><SaleBrokerForm /></ProtectedRoute>} />
      <Route path="/broker/edit/:id" element={<ProtectedRoute><SaleBrokerForm /></ProtectedRoute>} />
      <Route path="/purchase-broker" element={<ProtectedRoute><PurchaseBrokerList /></ProtectedRoute>} />
      <Route path="/purchase-broker/new" element={<ProtectedRoute><PurchaseBrokerForm /></ProtectedRoute>} />
      <Route path="/purchase-broker/edit/:id" element={<ProtectedRoute><PurchaseBrokerForm /></ProtectedRoute>} />

      <Route path="/cma" element={<ProtectedRoute><CmaList /></ProtectedRoute>} />
      <Route path="/cma/new" element={<ProtectedRoute><CmsWarehouseForm /></ProtectedRoute>} />
      <Route path="/cma/edit/:id" element={<ProtectedRoute><CmsWarehouseForm /></ProtectedRoute>} />
      <Route path="/cma/:cmaId/add-warehouses" element={<ProtectedRoute><CmaAddWarehousesForm /></ProtectedRoute>} />
      <Route path="/commodity" element={<ProtectedRoute><CommodityList /></ProtectedRoute>} />
      <Route path="/commodity/new" element={<ProtectedRoute><CommodityForm /></ProtectedRoute>} />
      <Route path="/commodity/edit/:id" element={<ProtectedRoute><CommodityForm /></ProtectedRoute>} />
      <Route path="/cost-breakup" element={<ProtectedRoute><CostBreakupList /></ProtectedRoute>} />
      <Route path="/cost-breakup/new" element={<ProtectedRoute><CostBreakupForm /></ProtectedRoute>} />
      <Route path="/cost-component" element={<ProtectedRoute><CostComponent /></ProtectedRoute>} />
      <Route path="/delivery-order" element={<ProtectedRoute><DeliveryOrderList /></ProtectedRoute>} />
      <Route path="/delivery-order/new" element={<ProtectedRoute><DeliveryOrderForm /></ProtectedRoute>} />
      <Route path="/delivery-order/view/:id" element={<ProtectedRoute><DeliveryOrderView /></ProtectedRoute>} />
      <Route path="/dispatch-entry" element={<ProtectedRoute><DispatchList /></ProtectedRoute>} />
      <Route path="/dispatch/new" element={<ProtectedRoute><DispatchEntryForm /></ProtectedRoute>} />
      <Route path="/document" element={<ProtectedRoute><DocumentList /></ProtectedRoute>} />
      <Route path="/document/new" element={<ProtectedRoute><DocumentUploadForm /></ProtectedRoute>} />
      <Route path="/document-type" element={<ProtectedRoute><DocumentType /></ProtectedRoute>} />
      <Route path="/fx-rate" element={<ProtectedRoute><FXRate /></ProtectedRoute>} />
      <Route path="/order-status" element={<ProtectedRoute><OrderStatus /></ProtectedRoute>} />
      <Route path="/payment" element={<ProtectedRoute><PaymentList /></ProtectedRoute>} />
      <Route path="/payment/new" element={<ProtectedRoute><PaymentForm /></ProtectedRoute>} />
      <Route path="/purchase-contract" element={<ProtectedRoute><PurchaseContractList /></ProtectedRoute>} />
      <Route path="/purchase-contract/new" element={<ProtectedRoute><PurchaseContract /></ProtectedRoute>} />
              <Route path="/purchase-contract/edit/:id" element={<ProtectedRoute><PurchaseContract /></ProtectedRoute>} />
      <Route path="/sale-broker" element={<ProtectedRoute><SaleBroker /></ProtectedRoute>} />
      <Route path="/sales-channel" element={<ProtectedRoute><SalesChannel /></ProtectedRoute>} />
      <Route path="/sales-order" element={<ProtectedRoute><SalesOrderList /></ProtectedRoute>} />
      <Route path="/sales-order/new" element={<ProtectedRoute><SalesOrderFrom /></ProtectedRoute>} />

      <Route path="/supplier" element={<ProtectedRoute><SupplierList /></ProtectedRoute>} />
      <Route path="/supplier/new" element={<ProtectedRoute><SupplierForm /></ProtectedRoute>} />
      <Route path="/supplier/:supplierId/edit" element={<ProtectedRoute><SupplierEditForm /></ProtectedRoute>} />
       <Route path="/company" element={<ProtectedRoute><CompanyList /></ProtectedRoute>} />
        <Route path="/company/new" element={<ProtectedRoute><CompanyForm /></ProtectedRoute>} />
        <Route path="/company/edit/:id" element={<ProtectedRoute><CompanyForm /></ProtectedRoute>} />
        <Route path="/company/:companyId/add-gst" element={<ProtectedRoute><CompanyAddGstForm /></ProtectedRoute>} />
      <Route path="/warehouse" element={<ProtectedRoute><Warehouse /></ProtectedRoute>} />
      <Route path="/warehouse-entry" element={<ProtectedRoute><WarehouseEntryList /></ProtectedRoute>} />
      <Route path="/warehouse-entry/new" element={<ProtectedRoute><WarehouseEntryForm /></ProtectedRoute>} />
      <Route path="/warehouse-transfer" element={<ProtectedRoute><WarehouseTransferList /></ProtectedRoute>} />
      <Route path="/warehouse-transfer/new" element={<ProtectedRoute><WarehouseTransferForm /></ProtectedRoute>} />
      <Route path="/masters" element={<ProtectedRoute><MastersOverview /></ProtectedRoute>} />
      <Route path="/roadmap" element={<ProtectedRoute><Roadmap /></ProtectedRoute>} />
      <Route path="/buyer" element={<ProtectedRoute><BuyerList /></ProtectedRoute>} />
      <Route path="/buyer/new" element={<ProtectedRoute><BuyerForm /></ProtectedRoute>} />
      <Route path="/buyer/edit/:id" element={<ProtectedRoute><BuyerForm /></ProtectedRoute>} />
      <Route path="/issuing-authorities" element={<ProtectedRoute><IssuingAuthoritiesList /></ProtectedRoute>} />
      <Route path="/issuing-authorities/add" element={<ProtectedRoute><IssuingAuthoritiesForm /></ProtectedRoute>} />
      <Route path="/received-payment" element={<ProtectedRoute><ReceivedPaymentList /></ProtectedRoute>} />
      <Route path="/received-payment/new" element={<ProtectedRoute><ReceivedPaymentForm /></ProtectedRoute>} />
      <Route path="/report/sales" element={<ProtectedRoute><SalesReport /></ProtectedRoute>} />
      <Route path="/report/purchase-summary" element={<ProtectedRoute><PurchaseSummaryReport /></ProtectedRoute>} />
      <Route path="/report/master-report" element={<ProtectedRoute><MasterReport /></ProtectedRoute>} />
      {/* Backup Management */}
      <Route path="/backup-management" element={<ProtectedRoute><BackupManagement /></ProtectedRoute>} />
      <Route path="/user-list" element={<UserList />} />
      {/* Default Route - Redirect to dashboard */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default AppRoutes;

